import { c as _c } from "react/compiler-runtime";
import { getAccessLevelItems } from "@components/access-level/access-level-utils";
import { Checkmark2Icon, FontWeights, MenuItem } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Access level dropdown */
export function AccessLevelDropdown(t0) {
  const $ = _c(9);
  const {
    type,
    currentAccessLevel,
    onSelectAccessLevel
  } = t0;
  let t1;
  if ($[0] !== currentAccessLevel || $[1] !== onSelectAccessLevel || $[2] !== type) {
    let t2;
    if ($[4] !== currentAccessLevel || $[5] !== onSelectAccessLevel) {
      t2 = accessLevel => <MenuItem data-my-value={accessLevel.value} key={accessLevel.value} value={accessLevel.value} selected={accessLevel.value === currentAccessLevel} onClick={() => onSelectAccessLevel(accessLevel.value)} sx={{
        display: "block",
        whiteSpace: "normal"
      }}><Box sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: "9px"
        }}><Box sx={{
            color: accessLevel.value === currentAccessLevel ? "primary.main" : "text.primary",
            fontSize: DEFAULT_INPUT_FONT_SIZE,
            fontWeight: FontWeights.SemiBold
          }}>{accessLevel.label}</Box>{accessLevel.value === currentAccessLevel && <Checkmark2Icon sx={{
            width: "21px",
            height: "21px",
            fill: PALETTE_VARS.primary.main
          }} />}</Box><Box sx={{
          color: "text.secondary",
          fontSize: "12px"
        }}>{accessLevel.description}</Box></MenuItem>;
      $[4] = currentAccessLevel;
      $[5] = onSelectAccessLevel;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = getAccessLevelItems(type).map(t2);
    $[0] = currentAccessLevel;
    $[1] = onSelectAccessLevel;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <>{t1}</>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}